<template>
  <div id="mainApp">
    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" app fixed :mini-variant="showMiniNav">
      <v-list dense :expand="true" class="py-3">
        <template v-for="item in visibleItems">
          <template v-if="shouldRender(item) && !(item.heading && showMiniNav)">
            <v-row v-if="item.heading" :key="item.heading + '-heading'" align="center" class="mt-2 mb-1">
              <v-col cols="6">
                <v-subheader class="px-4 py-2">{{ item.heading }}</v-subheader>
                <v-divider class="mx-2"></v-divider>
              </v-col>
            </v-row>
            <v-list-group v-else-if="item.children" v-model="item.model" :key="item.text" no-action sub-group>
              <v-list-item slot="activator">
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <div v-if="userIsAccountAdmin">
                <v-list-item v-for="(child, i) in item.children" :key="i" @click="navigateTo(child.path)" class="mb-1">
                  <v-list-item-action v-if="child.icon">
                    <v-icon v-if="!showMiniNav">{{ child.icon }}</v-icon>
                    <v-tooltip right v-if="showMiniNav">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">{{ child.icon }}</v-icon>
                      </template>
                      <span>{{ child.text }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-list-group>
            <v-list-item v-else :key="item.text" @click="navigateTo(item.path)" class="mb-1">
              <v-list-item-action>
                <v-icon v-if="!showMiniNav">{{ item.icon }}</v-icon>
                <v-tooltip right v-if="showMiniNav">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">{{ item.icon }}</v-icon>
                  </template>
                  <span>{{ item.text }}</span>
                </v-tooltip>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar clipped-left color="primary" dark app fixed elevation="3">
      <v-app-bar-nav-icon @click.stop="showMiniNav = !showMiniNav" class="mr-2"></v-app-bar-nav-icon>
      <v-app-bar-title>
        <!-- <v-app-bar-nav-icon @click.stop="showMiniNav = !showMiniNav"></v-app-bar-nav-icon> -->
        <span class="hidden-sm-and-down" @click="navigateTo('dashboard_path')">{{ appName }}</span>
      </v-app-bar-title>

      <v-spacer></v-spacer>

      <div v-show="dealerScopedView" class="d-flex align-center mr-4">
        <email-campaign-select v-model="jumpEmailCampaignId" :dealer_id="dealer.id"
          :email_campaign_id="jumpEmailCampaignId" v-on:selected-email-campaign="onEmailCampaignChange" class="mr-3">
        </email-campaign-select>
        <dealer-select label="Dealer" />
      </div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-avatar v-on="on" color="amber darken-2" size="36" class="ml-3">
            <v-icon dark>mdi-account</v-icon>
          </v-avatar>
        </template>
        <v-list class="py-1">
          <v-list-item v-for="(item, index) in userMenu" :key="index" @click="executeUserMenuAction(item.action)" class="px-4">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container fluid class="pa-6 pa-sm-4 pa-xs-3">
        <v-alert v-if="appNotification.type !== 'mini'" v-model="appNotification.visible"
          :dismissible="appNotification.showClose" :type="appNotification.type" transition="scale-transition"
          class="mb-6 elevation-2 rounded-lg">{{
            appNotification.message }}</v-alert>
        <v-snackbar v-if="appNotification.type === 'mini'" v-model="appNotification.visible" transition="scale-transition"
          top>
          {{ appNotification.message }}
          <v-btn v-if="appNotification.showClose" text color="pink" @click="appNotification.visible = false">
            Close
          </v-btn>
        </v-snackbar>
        <router-view />
      </v-container>
    </v-main>

    <!-- <v-footer :fixed="fixed" app>
      <v-col class="text-md-center" >
        <span v-html="$copyright"></span>
      </v-col>
    </v-footer> -->

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { DealerSelect, EmailCampaignSelect } from '@/components/inputs'

export default {
  components: {
    [DealerSelect.name]: DealerSelect,
    [EmailCampaignSelect.name]: EmailCampaignSelect
  },
  computed: {
    ...mapState('ApplicationStore', {
      appNotification: 'appNotification',
      AccountAdminGroup: state => state.groups.ACCOUNT_ADMIN
    }),
    ...mapState({
      user: state => state.cognito.user
    }),
    ...mapState('DealerStore', ['dealer']),
    ...mapState('ApplicationStore', ['dealerScopedView']),
    userGroups: function () {
      if (this.user) {
        return this.user.groups || []
      } else {
        return []
      }
    },
    showMiniNav: {
      get: function () {
        return this.$store.state.ApplicationStore.showMiniNav
      },
      set: function (val) {
        return this.$store.commit('ApplicationStore/setShowMiniNav', val)
      }
    },
    visibleItems() {
      return this.items.filter(item => {
        if (item.hidden !== true) {
          if (item.children) {
            item.children = item.children.filter(child => {
              if (child.hidden !== true) {
                return child
              }
            })
          }
          return item
        }
      })
    }
  },

  data: () => ({
    appName: 'DealerApps',
    dialog: false,
    drawer: true,
    fixed: false,
    jumpEmailCampaignId: null,
    items: [
      { icon: 'mdi-view-dashboard', text: 'Dashboard', path: 'dashboard_path' },
      { icon: 'mdi-account-search', text: 'Search', path: 'omni_search_path' },
      // EMAIL
      { heading: 'Email Content' },
      {
        icon: 'mdi-email-edit',
        text: 'Email Builder',
        path: 'email_builder_path'
      },
      {
        icon: 'mdi-page-layout-header-footer',
        text: 'Email Template Snippets',
        path: 'email_builder_snippets_path'
      },
      // DATASOURCES
      { heading: 'Datasources' },
      {
        icon: 'mdi-database-search',
        text: 'DMS Datasources',
        path: 'dms_datasources_path'
      },
      {
        icon: 'mdi-file-delimited',
        text: 'CSV Datasources',
        path: 'csv_datasources_path'
      },
      {
        icon: 'mdi-table-search',
        text: 'SQL Datasources',
        path: 'sql_datasources_path',
      },
      {
        icon: 'mdi-table-multiple',
        text: 'Csv Importer',
        path: 'csvtable_datasources_path',
        hidden: true
      },
      // CAMPAIGNS
      { heading: 'Campaigns' },
      {
        icon: 'mdi-bullhorn',
        text: 'Email Campaigns',
        path: 'email_campaigns_path'
      },
      // ADMIN
      { heading: 'Admin' },
      {
        icon: 'mdi-car-side',
        text: 'Dealers',
        path: 'dealers_path'
      },
      {
        renderCondition: 'userIsAccountAdmin',
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: 'Administration',
        model: false,
        children: [
          { icon: 'mdi-account-group', text: 'Users', path: 'users_path' }
        ]
      },
      // REPORTS
      { heading: 'Reports' },
      {
        icon: 'mdi-file-chart',
        text: 'Reports',
        path: 'reports_path'
      },
      {
        icon: 'mdi-database-clock',
        text: 'Scheduled Reports',
        path: 'datasource_mailers_path'
      },
      {
        icon: 'mdi-file-delimited',
        text: 'ROI CsvDatasource Reports',
        path: 'csv_datasource_reports_path'
      },
       // SYSTEM
      { heading: 'System' },
      {
        icon: 'mdi-domain-plus',
        text: 'Authenticated Domains',
        path: 'authenticated_domains_path'
      },
    ],
    userMenu: [
      { title: 'Profile', action: 'editProfile' },
      { title: 'Configure MFA', action: 'configureMfa' },
      { title: 'Change Password', action: 'changePassword' },
      { title: 'Logout', action: 'logout' }
    ]
  }),
  methods: {
    userIsAccountAdmin: function () {
      try {
        return this.userGroups.includes(this.AccountAdminGroup)
      } catch (error) {
        return false
      }
    },
    isAccountDealer() {
      return this.dealer.is_account_dealer
    },
    shouldRender: function (item) {
      // check if we have a conditional check
      if (item.renderCondition) {
        return this[item.renderCondition]() && item.hidden !== true
      } else {
        // no conditional check - render away
        return item.hidden !== true
      }
    },
    logout: function () {
      return this.$store
        .dispatch('signOut')
        .then(() => window.location.reload(true)) // forces a refresh back to login)
    },
    editProfile: function () {
      return this.navigateTo('edit_profile_path')
    },
    changePassword: function () {
      return this.navigateTo('change_password_profile_path')
    },
    configureMfa: function () {
      return this.navigateTo('configure_mfa_profile_path')
    },
    navigateTo: function (where) {
      if (where) {
        this.$router.push({ name: where }).catch(err => { })
      }
    },
    executeUserMenuAction(actionName) {
      return this[actionName]()
    },
    /* eslint handle-callback-err: ["error", "error"] */
    onEmailCampaignChange(emailCampaign) {
      if (emailCampaign.id) {
        this.$router.push({
          name: 'email_campaign_path',
          params: { id: emailCampaign.id }
        }).catch(err => { })
      }
      this.$nextTick(() => {
        this.jumpEmailCampaignId = null
      })
    }
  }
}
</script>
